<div class="relative max-w-2xl p-5 mx-auto bg-white rounded-md shadow-lg pb-7">
  <h2>Password Changed Successfully!</h2>
  <p class="my-2">You may now log in to QualityBidders and SecureBids with the new password.</p>
  <button mat-raised-button color="primary" (click)="login()">Log in</button>
</div>
